// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductDto, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { QuickProductLookupBaseModel } from "@stoneage/App/Services/QuickProductLookup/QuickProductLookupService";

export const setUrlsToQuickLookupProducts = (
    products: ProductModel[] | ProductDto[] | null,
    paginatedProducts: QuickProductLookupBaseModel[],
) => {
    const results = [...paginatedProducts];
    if (products && products?.length) {
        results.forEach((product, index) => {
            products.forEach((byProductNumber: ProductModel | ProductDto) => {
                const productNumber =
                    "productNumber" in byProductNumber
                        ? byProductNumber.productNumber
                        : (byProductNumber as ProductDto).erpNumber;
                const productUrl =
                    "productNumber" in byProductNumber
                        ? byProductNumber.canonicalUrl
                        : (byProductNumber as ProductDto).productDetailUrl;
                const unitOfMeasure =
                    "productNumber" in byProductNumber
                        ? byProductNumber.unitOfMeasures?.filter(uom => uom.isDefault)[0].unitOfMeasure
                        : (byProductNumber as ProductDto).unitOfMeasure;
                if (product.productNumber === productNumber) {
                    const newProduct = {
                        ...product,
                        url: productUrl,
                        urlIsSet: true,
                        productId: byProductNumber.id,
                        trackInventory: byProductNumber.trackInventory,
                        unitOfMeasure,
                    };
                    results[index] = newProduct;
                }
            });
        });
    }
    return results;
};
